import dynamic from 'next/dynamic'

export const DynamicGiftCardPurchaseConfirmationDialog = dynamic(
  () => import('.').then((mod) => mod.GiftCardPurchaseConfirmationDialog),
  { ssr: false },
)
